import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "MapParties" }


import MapParty from "./MapParty.vue";
import { Party } from "@/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'MapParties',
  props: {
    parties: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.parties, (party, index) => {
      return (_openBlock(), _createBlock(MapParty, {
        key: index,
        party: party
      }, null, 8, ["party"]))
    }), 128))
  ]))
}
}

})